/* stylelint-disable selector-class-pattern */
:host {
    display: block;
    box-sizing: border-box;
    user-select: none;
}

.badge-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-items: right;

    margin-top: 0;

    .badge-item {
        text-align: right;

        .badge-type--rewe-market,
        .badge-type--two-lines,
        .badge-type--two-lines-icon,
        .badge-type--plus-one-campaign,
        .badge-type--two-lines-discount,
        .badge-type--package-discount,
        .badge-type--wf-selection,
        .badge-type--alc-free {
            --wf-badge-font-size: 12px;
        }

        .badge-type--two-lines,
        .badge-type--alc-free,
        .badge-type--rewe-market,
        .badge-type--two-lines-discount {
            --wf-badge-padding-top: 6px;
        }

        .badge-type--plus-one-campaign {
            --wf-badge-line-1-font-size: 20px;
            --wf-badge-padding-top: 2px;
        }

        .badge-type--two-lines-discount {
            --wf-badge-line-2-font-size: 20px;
            --wf-badge-padding-bottom: 2px;
        }

        .badge-type--package-discount {
            --wf-badge-line-1-font-size: 20px;
            --wf-badge-padding-top: 2px;
        }

        .badge-type--wf-selection {
            --wf-badge-text-align: center;
            --wf-badge-background-color: var(--wf-champagne-01, #bea07e);
            --wf-badge-line-1-font-size: 8px;
            --wf-badge-line-1-font-weight: normal;
            --wf-badge-line-1-line-height: 12px;
            --wf-badge-line-2-font-size: 12px;
            --wf-badge-line-2-font-family: "Tiempos", serif;
            --wf-badge-margin-top: -3px;
        }

        .badge-type--rewe-market {
            --wf-badge-background-color: var(--wf-traubenrot-01, #52234a);
        }

        .badge-type--bio,
        .badge-type--vegan,
        .badge-type--alc-free {
            --wf-badge-background-color: var(--wf-weingruen-01, #adc13f);
        }
    }
}
